import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";
import { DatePipe } from "@angular/common";
import { environment } from "../../environments/environment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { GoogleApiServices } from "../services/google.api.service";
import { AppointmentSharedService } from "../services/appointment-shared.service";

@Component({
  selector: "app-appointment-confirm",
  templateUrl: "./appointment-confirm.component.html",
  styleUrls: ["./appointment-confirm.component.scss"],
})
export class AppointmentConfirmComponent implements OnInit {
  validationMessage: any;
  path: any;
  selectedlang: any;
  couldFrontURL = environment.cloudFrontURL;
  scheduleappointmentid: any = "";
  validateEmail = false;
  showExamdetails = false;
  countryCodeNew = "";
  modalRef: BsModalRef;
  config = {
    ignoreBackdropClick: true,
  };
  alert: any;
  generalvalidationMessage: any;
  scheduledpatient: any = {};
  scheduleDateShow: any;
  lat: number;
  lng: number;
  havingaddress = false;
  medicalqnsList: any = [];
  @ViewChild("generalvalidation") generalvalidation: TemplateRef<any>;

  constructor(
    private appservice: AppService,
    private datepipe: DatePipe,
    private router: Router,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private gapi: GoogleApiServices,
    private shared: AppointmentSharedService
  ) {}

  ngOnInit() {
    this.shared.initFromRoute(this);
  }

  durationFunction(data) {
    return this.shared.durationFunction(data);
  }

  showExams() {
    this.shared.showExams(this);
  }

  hideExams() {
    this.shared.hideExams(this);
  }

  getscheduleappointmentId() {
    this.shared.getscheduleappointmentId(this);
  }

  calendarurl: any;
  getCalendarURL() {
    this.shared.getCalendarURL(this);
  }
  getLanguage() {
    this.shared.getLanguage(this);
  }

  openModal(template: TemplateRef<any>) {
    this.shared.openModal(this, template);
  }

  confirmationPop() {
    this.shared.confirmationPop(this);
  }
  closemodel() {
    this.shared.closemodel();
  }
  viewpatient() {
    this.appservice
      .viewscheduleappointment(this.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.scheduledpatient = res["entity"];
            if (
              this.scheduledpatient.addressLine1 !== null &&
              this.scheduledpatient.addressLine1 !== " "
            ) {
              this.havingaddress = true;
            } else {
              this.havingaddress = false;
            }
            this.shared.applyPatientLocationAndDate(this);
          }
        } else {
          this.router.navigate(["/home"]);
        }
      });
  }

  getmedicalqns() {
    this.appservice.getmedicalqns(this.scheduleappointmentid).subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.medicalqnsList = res["entity"];
        }
      },
      (err) => ({})
    );
  }

  cancelAppointment() {
    this.shared.cancelAppointment(this);
  }

  goToHomePage() {
    this.shared.goToHomePage(this);
  }

  goToHomePageNew() {
    this.shared.goToHomePageNew(this);
  }

  goToThankYouPage() {
    this.shared.goToThankYouPage(this);
  }

  checkValue() {
    // this.validateEmail = !this.validateEmail;
  }

  updatenotify(type) {
    this.shared.updatenotify(this);
  }

  addGoogleCalendar() {
    this.shared.addGoogleCalendar(this);
  }
}
